<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6">
                <el-input v-model="filter.notification" prefix-icon="el-icon-search" :placeholder="$t('masters.searchNotifications')"></el-input>
            </el-col>
            <el-col :span="4">
                <country-selector clearable v-model="filter.countryId"></country-selector>
            </el-col>
            <el-col :span="4">
                <chain-selector v-model="filter.chainId"></chain-selector>
            </el-col>
            <el-col :span="3">
                <el-input v-model="filter.text" prefix-icon="el-icon-search" :placeholder="$t('common.name')"></el-input>
            </el-col>
        </el-row>
        <el-table size="mini" :data="customers" @sort-change="sortChanged" @expand-change="expanded" v-loading="loading" class="orders-table tablewithshading">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-table size="mini" :data="customerNotifications[props.row.id]" class="tablewithshading" v-if="customerNotifications[props.row.id] && customerNotifications[props.row.id].length > 0">
                        <el-table-column prop="message" :label="$t('masters.messages')"></el-table-column>
                        <el-table-column :label="$t('common.operations')" fixed="right" width="160px">
                            <template slot-scope="scope">
                                <el-button size="mini" @click="editNotification(props.row.id, scope.row.id)">
                                    <i class="el-icon-edit"></i>
                                </el-button>
                                <el-button size="mini" type="danger" @click="deleteNotification(props.row.id, scope.row.id)">
                                    <i class="el-icon-delete"></i>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-alert :closable="false" :title="$t('masters.customerHasNoNotifications')" v-if="!customerNotifications[props.row.id] || customerNotifications[props.row.id].length === 0" type="info"></el-alert>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="no" :label="$t('common.number')"></el-table-column>
            <el-table-column sortable="custom" prop="name" :label="$t('common.name')"></el-table-column>
            <el-table-column prop="country" :label="$t('common.country')"></el-table-column>
            <el-table-column :label="$t('common.phone')">
                <template slot-scope="scope">
                    <a :href="'callto:'+scope.row.phone">{{scope.row.phone}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="count" :label="$t('masters.numberOfNotifications')"></el-table-column>
            <el-table-column :label="$t('common.operations')" fixed="right" width="160px">
                <template slot-scope="scope">
                    <el-button size="mini" @click="addNotification(scope.row.id)">
                        <i class="el-icon-plus"></i>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager" v-if="total !== 0" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="total">
        </el-pagination>
        <promptDialog :visible="dialogVisible" @promptDialogClosed="closePromptDialog" @notification="addNote" :notificationMessage="notification"></promptDialog>
    </div>
</template>

<script>
    import Vue from "vue";
    import ChainSelector from "./ChainSelector";
    import { CountrySelector } from "@/app/shared/components";
    import promptDialog from './PromptDialog'
    import api from "../api";

    export default {
        name: "customernotification-list",
        components: {
            CountrySelector,
            ChainSelector,
            promptDialog
        },
        data() {
            return {
                customers: [],
                customerNotifications: [],
                loading: true,
                exporting: false,
                dialogVisible: false,
                customerToEdit: undefined,
                notification: '',
                notificationId: null,
                filter: {
                    countryId: undefined,
                    chainId: undefined,
                    text: undefined,
                    notification: undefined
                },
                sort: undefined,
                currentPage: 1,
                total: 0
            };
        },
        created() {
            this.loadCustomers();
        },
        watch: {
            filter: {
                deep: true,
                handler: function (val) {
                    this.loadCustomers();
                }
            }
        },
        methods: {
            sortChanged(sort) {
                this.sort = sort;
                if (this.currentPage === 1) {
                    this.loadCustomers();
                } else {
                    this.currentPage = 1;
                }
            },
            expanded(row, expandedRows) {
                let isExpanded = expandedRows.indexOf(row);
                if (isExpanded !== -1) {
                    api.getNotifications(row.id).then(response => {
                        Vue.set(this.customerNotifications, row.id, response.data);
                    });
                }
            },
            loadCustomers()
            {
                this.loading = true;
                api
                    .getCustomers(
                        this.currentPage,
                        this.filter.countryId,
                        this.filter.chainId,
                        this.filter.text,
                        "",
                        "",
                        "",
                        this.sort,
                        this.filter.notification
                    )
                    .then(response =>
                    {
                        this.loading = false;
                        this.customers = response.data.items.map(obj => ({ ...obj, count: obj.notifications.length }));
                        this.total = response.data.total;
                    });
            },
            closePromptDialog()
            {
                this.dialogVisible = false
            },
            addNote(message)
            {
                var date = new Date().toLocaleDateString() + " - " + this.$currentUser.profile.name + " ";
                var notification = {
                    id: this.notificationId,
                    message: (message.split(/\d\/\d\/\d\d\d\d - /)[0] ? message.split(/\d\/\d\/\d\d\d\d - /)[0] : message) + " " + date
                };
                api.saveNotification(this.customerId, notification).then(() =>
                {
                    this.loadNotifications(this.customerId);
                    this.$notify({
                        title: this.$t('common.success'),
                        message: this.$t('common.notifySuccesfullySaved'),
                        type: "success"
                    });

                    if (!this.notificationId)
                    {
                        this.loadCustomers();
                    }
                });


            },
            addNotification(customerId)
            {
                this.notificationId = null;
                this.customerId = customerId;
                this.dialogVisible = true;
                this.notification = '';

            },
            loadNotifications(customerId)
            {
                api.getNotifications(customerId).then(response =>
                {
                    //this.customerNotifications[customerId] = response.data;
                    Vue.set(this.customerNotifications, customerId, response.data);
                    console.log(response.data)
                });
            },
            editNotification(customerId, notificationUpdated)
            {
                var notification = this.customerNotifications[customerId].find(
                    x => x.id == notificationUpdated
                );

                this.notification = notification.message;
                this.notificationId = notification.id;
                this.customerId = customerId;

                this.dialogVisible = true;
            },
            deleteNotification(customerId, id)
            {
                this.$confirm(this.$t('common.thisWillDeleteNotificationContinue'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                })
                    .then(() =>
                    {
                        api.deleteNotification(id).then(() =>
                        {
                            this.loadNotifications(customerId);
                            this.$message({
                                type: "success",
                                message: this.$t('common.deleteCompleted')
                            });
                            this.loadCustomers();
                        });
                    })
                    .catch(_ => { });
            },
            handleCurrentChange(page)
            {
                this.currentPage = page;
                this.loadCustomers();
            },
        }
    };

</script>


// WEBPACK FOOTER //
// ClientApp/app/masters/customers/components/CustomerNotificationList.vue